import { format } from 'date-fns';
import { ExaminationItemResult } from './types';

const examinationItemParser = (data: ExaminationItemResult): ExaminationItemResult => ({
  id: data!.id || '',
  student_id: data!.student_id || '',
  group_id: data!.group_id || '',
  test_task_id: data!.test_task_id || '',
  count_attempt: data!.count_attempt || '',
  points_received: data!.points_received || '',
  evaluation: data!.evaluation || '',
});

export default examinationItemParser;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/examinationItemResultParser.ts